import React from 'react';
import { FaVideo } from 'react-icons/fa';
import "./StartBroadcastButton.css"

const StartBroadcastButton = ({ onClick }) => {
  return (
    <button className="start-broadcast-btn" onClick={onClick}>
      <FaVideo className="btn-icon" />
      <span className="btn-text">Start Broadcast</span>
    </button>
  );
};

export default StartBroadcastButton;
